<template>
  <div class="p-login-copyright">
    <div class="p-login-copyright__item">Copyright © 2018-{{ endYear }} SiGNITY Inc. All rights reserved</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      endYear: null
    }
  },
  mounted: function() {
    const currentDate = new Date();
    this.endYear = currentDate.getFullYear();
  }
}
</script>